const API_BASE_URL = process.env.REACT_APP_BACKEND_URL ;  
// const API_BASE_URL = "http://localhost:8000";

export const getUserProfile = async (token) => {
  try {
    const res = await fetch(`${API_BASE_URL}/auth/profile`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    if (!res.ok) {
      // Якщо бекенд повернув 4xx або 5xx
      throw new Error(`Failed to fetch user profile. Status: ${res.status}`);
    }

    const data = await res.json(); 
    return data;                   
  } catch (error) {
    console.error("Помилка отримання профілю користувача:", error);
    return null; 
  }
};
